<template>
  <div class="centered-containerlogin">
    <v-card>
      <div class="title">
        <img src="/scrapingant-logo.png" />
        <div class="cardTitle">Please, wait a few moments</div>
        <div class="cardBody">You'll be redirected to the dashboard soon</div>
      </div>

      <div class="loading-overlay" v-if="loading">
        <v-progress-circular
          :size="50"
          :width="2"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>

<script>
import {getCookie} from "@/utils/common_utils";

export default {
  name: "LoginSocialRedirect",
  data() {
    return {
      loading: false,
      error: {},
      data: {
        code: "",
        type: "",
        state: "",
      },
    };
  },

  mounted() {
    this.data.code = this.$route.query.code;
    this.data.type = this.$route.params.type;
    this.data.state = this.$route.query.state;

    if (!!this.data.code && !!this.data.type) {
      this.auth_social();
    }
  },

  methods: {
    errors(res) {
      this.error = Object.fromEntries(
        res.data.errors.map((item) => [item.field, item.msg])
      );
    },

    auth_social() {
      const userSource = getCookie('user_source');
      this.$store.dispatch("auth/social_received",
          {
            ...this.data,
            user_source: userSource ? userSource : "direct"
          }
      ).then(
        () => {
          this.loading = false;
          this.$router.push({
            name: "Dashboard",
          });
        },
        (err) => {
          this.loading = false;
          this.errors(err.response);
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.cardTitle {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.005em;
  line-height: 26px;
}
.cardBody {
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
}
</style>
